import UniversalChat from '../../components/common/UniversalChat';
import { useAuth } from '../../context/AuthContext';
import { usePermissions } from '../../hooks/usePermissions';

function ChatSection() {
  const { user } = useAuth();
  const { canWrite } = usePermissions();
  const chatCanWrite = canWrite('chat');
  return <UniversalChat currentUserId={user?.userId} canWrite={chatCanWrite} />;
}

export default ChatSection;
